import {TemplateList} from "~/libs/constants/TemplateList"
import type StaticMenuItem from "~/libs/interfaces/StaticMenuItem"
export const MenuFooterCategoriesConfig: Record<TemplateList, StaticMenuItem[]> = {
  [TemplateList.POGGERS]: [
    {
      name: 'Aktuálně',
      items: [
        {
          name: 'Epicentrum',
          url: 'https://www.blesk.cz/epicentrum',
          target: '_blank',
        },
        {
          name: 'Druhy fóbií a léčba',
          url: 'https://www.mojepsychologie.cz/fobie-druhy-a-lecba',
          target: '_blank',
        },
        {
          name: 'Státní svátky v roce 2024',
          url: 'https://www.e15.cz/statni-svatky-2024-cr-kalendar',
          target: '_blank',
        },
        {
          name: 'Mentální věk',
          url: 'https://www.mojepsychologie.cz/relax/testy-a-kvizy/test-na-datu-v-obcance-nezalezi-jaky-je-vas-mentalni-vek-533',
          target: '_blank',
        },
        {
          name: 'Změna času 2024',
          url: 'https://vtm.zive.cz/clanky/zmena-casu-kdy-se-meni-letni-cas-a-zimni-cas/sc-870-a-190726/default.aspx',
          target: '_blank',
        },
        {
          name: 'Úplňky 2024',
          url: 'https://horoskopy.blesk.cz/kdy-bude-uplnek-prehled',
          target: '_blank',
        }
      ]
    },
    {
      name: 'Vánoce 2024',
      url: 'https://prozeny.blesk.cz/kdy-budou-vanoce-datum-volno-prazdniny',
      target: '_blank',
      items: [
        {
          name: 'Otevírací doba',
          url: 'https://www.e15.cz/obchody-vanoce-kdy-je-zavreno-otevreno',
          target: '_blank',
        },
        {
          name: 'Vánoční trhy v Praze',
          url: 'https://www.e15.cz/vanocni-trhy-praha-2024',
          target: '_blank',
        },
        {
          name: 'Vánoční trhy v Evropě',
          url: 'https://prozeny.blesk.cz/kde-jsou-nejhezci-vanocni-trhy-v-evrope',
          target: '_blank',
        },
        {
          name: 'Kdy chodí Mikuláš?',
          url: 'https://www.dama.cz/clanek/kdy-chodi-mikulas-datum-zvyky-tradice-a-mikulasska-nadilka',
          target: '_blank',
        },
        {
          name: 'Vánoční cukroví',
          url: 'https://recepty.cz/vanocni-cukrovi-kucharka',
          target: '_blank',
        },
        {
          name: 'Black Friday 2024',
          url: 'https://www.e15.cz/kdy-je-black-friday',
          target: '_blank',
        }
      ]
    },
    {
      name: 'Politika',
      url: 'https://www.e15.cz/domaci',
      target: '_blank',
      items: [
        {
          name: 'Válka na Ukrajině',
          url: 'https://www.e15.cz/ukrajina-vs-rusko-konflikt-valka-aktualne',
          target: '_blank',
        },
        {
          name: 'Kdy budou volby',
          url: 'https://www.e15.cz/kdy-budou-volby',
          target: '_blank',
        },
        {
          name: 'Eurovolby 2024',
          url: 'https://www.e15.cz/eurovolby-datum-volby-do-eu',
          target: '_blank',
        },
        {
          name: 'Pásmo Gazy a Izrael',
          url: 'https://www.e15.cz/izrael-pasmo-gazy-mapa-valka-historie-2023',
          target: '_blank',
        },
        {
          name: 'Volby v USA 2024',
          url: 'https://www.e15.cz/volby/volby-v-usa/prezidentske-volby-v-usa-2024-termin-pruzkumy-kandidati-1412943',
          target: '_blank',
        },
        {
          name: 'Divoký kačer',
          url: 'https://www.reflex.cz/kategorie/7214/divoky-kacer',
          target: '_blank',
        }
      ]
    },
    {
      name: 'Stardance 2024',
      url: 'https://www.blesk.cz/stardance-2024-soutezici-porota-terminy-vysledky',
      target: '_blank',
      items: [
        {
          name: 'Taneční páry',
          url: 'https://www.blesk.cz/clanek/celebrity-stardance/794978/vsichni-soutezici-stardance-2024-kdo-s-kym-letos-tanci.html',
          target: '_blank',
        },
        {
          name: 'Program',
          url: 'https://sportovniprogram.cz/stardance',
          target: '_blank',
        },
        {
          name: 'Tipovačka',
          url: 'https://stardance.blesk.cz/',
          target: '_blank',
        },
        {
          name: 'Vstupenky',
          url: 'https://www.blesk.cz/clanek/celebrity-stardance/786468/stardance-2024-vstupenky-generalka-soutez-jak-ziskat-listky.html',
          target: '_blank',
        },
        {
          name: 'Písničky',
          url: 'https://www.dama.cz/clanek/stardance-2024-pisnicky-tance-a-hodnoceni-2-kola',
          target: '_blank',
        },
        {
          name: 'Zdeněk Chlopčík',
          url: 'https://www.blesk.cz/clanek/celebrity-stardance/797099/exporotce-zdenek-chlopcik-o-vyzvach-k-navratu-stardance-to-uz-me-nezajima.html',
          target: '_blank',
        }
      ]
    },
    {
      name: 'Technologie',
      url: 'https://www.zive.cz/technologie/sc-249/default.aspx',
      target: '_blank',
      items: [
        {
          name: 'ChatGPT',
          url: 'https://www.e15.cz/chatgpt-cz-co-to-je-chatbot-jak-funguje-cesky',
          target: '_blank',
        },
        {
          name: 'Black Friday, slevy',
          url: 'https://www.zive.cz/clanky/black-friday/sc-3-a-219308/default.aspx',
          target: '_blank',
        },
        {
          name: 'Jak stáhnout video z Youtube',
          url: 'https://www.zive.cz/clanky/jak-stahnout-video-z-youtube/sc-3-a-187091/default.aspx#part=1',
          target: '_blank',
        },
        {
          name: 'Nejlepší bezdrátová sluchátka',
          url: 'https://avmania.zive.cz/nejlepsi-bezdratova-sluchatka#part=1',
          target: '_blank',
        },
        {
          name: 'Filmy a seriály na Max',
          url: 'https://avmania.zive.cz/nejoblibenejsi-filmy-a-serialy-na-hbo-max',
          target: '_blank',
        },
        {
          name: 'Netflix filmy a seriály',
          url: 'https://avmania.zive.cz/nejoblibenejsi-filmy-a-serialy-na-netflixu#part=1',
          target: '_blank',
        }
      ]
    },
    {
      name: 'Ekonomika',
      url: 'https://www.e15.cz/',
      target: '_blank',
      items: [
        {
          name: 'Elektronická dálniční známka',
          url: 'https://www.e15.cz/byznys/doprava-a-logistika/elektronicka-dalnicni-znamka-cena-cr-rakousko-slovensko-madarsko',
          target: '_blank',
        },
        {
          name: 'Spořící účty',
          url: 'https://www.e15.cz/sporici-ucty-srovnani',
          target: '_blank',
        },
        {
          name: 'Průměrná mzda v ČR',
          url: 'https://www.e15.cz/prumerna-mzda-cr-praha',
          target: '_blank',
        },
        {
          name: 'Výpočet důchodu',
          url: 'https://www.e15.cz/kalkulacka-vypocet-duchodu',
          target: '_blank',
        },
        {
          name: 'Daňové přiznání 2024',
          url: 'https://www.e15.cz/finexpert/danove-priznani/danove-priznani-2024-termin-kdy-a-jak-priznat-dane-za-rok-2023-1395625',
          target: '_blank',
        },
        {
          name: 'Paušální daň 2024',
          url: 'https://www.e15.cz/finexpert/danove-priznani/pausalni-dan-pro-osvc-2024-pasma-a-podminky-vyplati-se-vam-1411002',
          target: '_blank',
        }
      ]
    },
  ],
  [TemplateList.MATERIDOUSKA]: [
    {
      name: 'Maminka.cz',
      items: [
        {
          name: 'Těhotenství',
          url: 'https://www.maminka.cz/tehotenstvi',
          target: '_blank',
        },
        {
          name: 'Porod',
          url: 'https://www.maminka.cz/porod',
          target: '_blank',
        },
        {
          name: 'Děti',
          url: 'https://www.maminka.cz/deti',
          target: '_blank',
        },
        {
          name: 'Podcasty',
          url: 'https://www.maminka.cz/tema/podcasty',
          target: '_blank',
        },
      ]
    },
    {
      name: 'Pigy.cz',
      items: [
        {
          name: 'Rádia',
          url: 'https://www.pigy.cz/radia/',
          target: '_blank',
        },
        {
          name: 'Akce',
          url: 'https://www.pigy.cz/rubrika-novinek/akce/',
          target: '_blank',
        },
        {
          name: 'Videa',
          url: 'https://www.pigy.cz/video/',
          target: '_blank',
        },
        {
          name: 'Zábava',
          url: 'https://www.pigy.cz/zabava/',
          target: '_blank',
        },
      ]
    },
    {
      name: 'Pigymama.cz',
      items: [
        {
          name: 'Blog',
          url: 'https://mama.pigy.cz/category/zabava',
          target: '_blank',
        },
        {
          name: 'Kam s dětmi',
          url: 'https://mama.pigy.cz/category/akce/kam-s-detmi/',
          target: '_blank',
        },
        {
          name: 'Tvoření',
          url: 'https://mama.pigy.cz/category/tvoreni/',
          target: '_blank',
        },
        {
          name: 'Tipy a rady',
          url: 'https://mama.pigy.cz/category/tipy-rady',
          target: '_blank',
        },
      ]
    },
    {
      name: 'Mimibazar',
      items: [
        {
          name: 'Inzeráty',
          url: 'https://www.mimibazar.cz/nove_fotografie.php?order=1',
          target: '_blank',
        },
        {
          name: 'Testujeme',
          url: 'https://www.mimibazar.cz/testovani/',
          target: '_blank',
        },
        {
          name: 'Recepty',
          url: 'https://www.mimibazar.cz/recepty.php',
          target: '_blank',
        },
        {
          name: 'Diskuze',
          url: 'https://www.mimibazar.cz/recepty.php?modal=search',
          target: '_blank',
        },
      ]
    },
    {
      name: 'ABC',
      items: [
        {
          name: 'Video',
          url: 'https://www.abicko.cz/kategorie/3096/video',
          target: '_blank',
        },
        {
          name: 'Příroda',
          url: 'https://www.abicko.cz/kategorie/559/priroda',
          target: '_blank',
        },
        {
          name: 'Komiksy',
          url: 'https://www.abicko.cz/kategorie/558/komiksy',
          target: '_blank',
        },
        {
          name: 'Vystřihovánky',
          url: 'https://www.abicko.cz/kategorie/550/vystrihovanky',
          target: '_blank',
        },
      ]
    },
    {
      name: 'Startjob',
      items: [
        {
          name: 'Pro uchazeče',
          url: 'https://www.starjob.cz/#proUchazece',
          target: '_blank',
        },
        {
          name: 'Na pohovoru zazáříte',
          url: 'https://muj.starjob.cz/cs',
          target: '_blank',
        },
        {
          name: 'Přihlásit se',
          url: 'https://muj.starjob.cz/cs/login?redirectTo=%2Fhome',
          target: '_blank',
        },
        {
          name: 'Kontrola CV',
          url: 'https://muj.starjob.cz/cs',
          target: '_blank',
        },
      ]
    },
  ],
  [TemplateList.HEYFOMO]: [],
}